// src/components/UserRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const UserRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  console.log('🔍 UserRoute check - User:', user);
  console.log('🔍 UserRoute check - isAdmin:', user?.isAdmin);
  console.log('🔍 UserRoute check - role:', user?.role);
  
  // ✅ Show loading while checking authentication
  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px'
      }}>
        Loading...
      </div>
    );
  }
  
  // ✅ Check if user is logged in
  if (!user) {
    console.log('❌ UserRoute: No user found, redirecting to login');
    return <Navigate to="/login" replace />;
  }
  
  // ✅ Check if user is admin (redirect to admin area)
  const isAdmin = user.isAdmin || user.role === 'admin';
  
  if (isAdmin) {
    console.log('🔒 UserRoute: Admin detected, redirecting to admin area');
    return <Navigate to="/admin" replace />;
  }
  
  console.log('✅ UserRoute: Regular user access granted');
  return children;
};

export default UserRoute;
